<template>
  <v-app>
    <v-main>
      <RequestHeader @fileImport='fileImport'></RequestHeader>
        <maoc-form ref="mainForm"></maoc-form>
      <RequestFooter></RequestFooter>
    </v-main>
  </v-app>
</template>

<script>
import MaocForm from './components/MaocForm'
import RequestHeader from './components/RequestHeader'
import RequestFooter from './components/RequestFooter'

import './styles/style.scss'

export default {
  name: 'App',
  components: {
    MaocForm,
    RequestHeader,
    RequestFooter
  },
  methods: {
    fileImport: function (file) {
      this.$refs.mainForm.importFile(file)
    }
  }
}
</script>
